import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import Skeleton from "../../../../../../structures/others/skeleton/index.js";
import * as S from "./styled.js";
export const CardSkeletonMobile = ()=>/*#__PURE__*/ _jsxs(S.SkeletonItem, {
        className: "item",
        "data-testid": "CardSkeletonMobile",
        children: [
            /*#__PURE__*/ _jsx(S.SkeletonImages, {
                children: /*#__PURE__*/ _jsx(Skeleton, {
                    variant: "rectangular",
                    animation: "wave",
                    height: "112px"
                })
            }),
            /*#__PURE__*/ _jsxs(S.SkeletonContent, {
                children: [
                    /*#__PURE__*/ _jsx(Skeleton, {
                        variant: "rectangular",
                        animation: "wave",
                        width: "90%",
                        style: {
                            minHeight: '18px'
                        }
                    }),
                    /*#__PURE__*/ _jsx(Skeleton, {
                        variant: "rectangular",
                        animation: "wave",
                        width: "40%",
                        style: {
                            minHeight: '18px'
                        }
                    }),
                    /*#__PURE__*/ _jsx(Skeleton, {
                        variant: "rectangular",
                        animation: "wave",
                        width: "60%",
                        style: {
                            minHeight: '18px'
                        }
                    })
                ]
            })
        ]
    });
export default CardSkeletonMobile;

//# sourceMappingURL=index.js.map